import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-list',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchListComponent implements OnInit {

  @Output() keyupAreas = new EventEmitter();
  key = '';

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  filterAddress(event) {
    this.keyupAreas.emit(event.target.value);
  }

}
